export const exportData = (res, templateReport = '') => {
  // Get the file type
  const fileType = res?.data?.type
  //Create a Blob from the PDF Stream
  const file = new Blob([res.data], { type: fileType })
  //Build a URL from the file
  const fileURL = URL.createObjectURL(file)
  //Open the URL on new Window

  if (fileType === 'application/pdf') {
    // Open PDF file in new window
    window.open(fileURL)
  } else if (fileType === 'text/csv') {
    // Read CSV file and display it in a new window as a table
    const reader = new FileReader()

    reader.onload = function (e) {
      const csvData = e.target.result

      // Open a new window
      const newWindow = window.open('', 'CSV Viewer', 'width=800,height=600')

      // Create a basic HTML structure
      let htmlContent = `<html><head><title>${templateReport} CSV</title></head><body>`
      htmlContent += `<h1>${templateReport}</h1>
      <table border="1" cellpadding="5" cellspacing="0">`

      // Convert CSV data to an HTML table
      const rows = csvData.trim().split('\n')
      rows.forEach((row) => {
        const cells = row.split(',')
        htmlContent += '<tr>'
        cells.forEach((cell) => {
          htmlContent += `<td>${cell}</td>`
        })
        htmlContent += '</tr>'
      })

      htmlContent += '</table></body></html>'

      // Write the HTML content to the new window
      newWindow.document.write(htmlContent)
      newWindow.document.close()
    }

    // Read the CSV file as text
    reader.readAsText(file)
    window.open(fileURL)
  } else {
    // For other types, just open the file directly
    window.open(fileURL)
  }
}
